export default __webpack_public_path__ + "static/media/footer_mobile.063eb535.svg";